import React from 'react';

const TrustSection = () => {
    const certifications = [
        {
            id: 1,
            name: "Adobe Commerce Expert Front End Developer",
            provider: "Adobe",
            icon: "🏆"
        },
        {
            id: 2,
            name: "Adobe Commerce Professional Developer",
            provider: "Adobe",
            icon: "🏆"
        },
        {
            id: 3,
            name: "BigCommerce Certified Developer",
            provider: "BigCommerce",
            icon: "🏆"
        },
        {
            id: 4,
            name: "Shopware 6 Certified Frontend Developer",
            provider: "Shopware",
            icon: "🏆"
        },
        {
            id: 5,
            name: "Shopware 6 Certified Backend Developer",
            provider: "Shopware",
            icon: "🏆"
        },
        {
            id: 6,
            name: "Shopware 6 Certified Solutions Architect",
            provider: "Shopware",
            icon: "🏆"
        }
    ];

    return (
        <section className="section trust-section">
            <div className="container">
                <h2 className="section-title">Certifications & Expertise</h2>
                <p className="section-subtitle">
                    Platform-certified expertise backed by years of hands-on ecommerce development
                </p>

                <div className="certifications-grid">
                    {certifications.map((cert) => (
                        <div key={cert.id} className="certification-badge">
                            <span className="icon">{cert.icon}</span>
                            <div>
                                <div className="certification-badge__name">
                                    {cert.name}
                                </div>
                                <div className="certification-badge__provider">
                                    {cert.provider}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="platform-badges">
                    <span className="badge badge--bigcommerce">BigCommerce</span>
                    <span className="badge badge--magento">Magento 2</span>
                    <span className="badge badge--shopware">Shopware 6</span>
                    <span className="badge badge--woocommerce">WooCommerce</span>
                </div>
            </div>
        </section>
    );
};

export default TrustSection;